import React from 'react';
import Tooltip from '@spark/ui-components/components/Tooltip';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';

const formatNumber = (value, decimals) => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  const parsed = Number(value);
  if (Number.isNaN(parsed)) {
    return String(value);
  }

  return parsed.toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};

const renderTextCell = (value, maxLength) => {
  const text = value || '-';
  if (text === '-') {
    return text;
  }

  return (
    <Tooltip dir="top" text={text}>
      <div style={{ cursor: 'pointer' }}>
        <TruncatedText value={text} maxLength={maxLength} />
      </div>
    </Tooltip>
  );
};

export const getPremiacaoConsolidadoColumns = () => [
  {
    id: 'frotaCavalo',
    accessorKey: 'frotaCavalo',
    header: 'Frota',
    size: 100,
    cell: ({ row }) => renderTextCell(row.original.frotaCavalo, 12)
  },
  {
    id: 'cpfMotorista',
    accessorKey: 'cpfMotorista',
    header: 'CPF',
    size: 130,
    cell: ({ row }) => row.original.cpfMotorista || '-'
  },
  {
    id: 'motorista',
    accessorKey: 'motorista',
    header: 'Motorista',
    size: 180,
    cell: ({ row }) => renderTextCell(row.original.motorista, 22)
  },
  {
    id: 'mesFechamento',
    accessorKey: 'mesFechamento',
    header: 'Mês',
    size: 70,
    cell: ({ row }) => row.original.mesFechamento ?? '-'
  },
  {
    id: 'anoFechamento',
    accessorKey: 'anoFechamento',
    header: 'Ano',
    size: 80,
    cell: ({ row }) => row.original.anoFechamento ?? '-'
  },
  {
    id: 'kmRodado',
    accessorKey: 'kmRodado',
    header: 'Km Rodado',
    size: 110,
    cell: ({ row }) => formatNumber(row.original.kmRodado, 2)
  },
  {
    id: 'litros',
    accessorKey: 'litros',
    header: 'Litros',
    size: 100,
    cell: ({ row }) => formatNumber(row.original.litros, 2)
  },
  {
    id: 'media',
    accessorKey: 'media',
    header: 'Média',
    size: 90,
    cell: ({ row }) => formatNumber(row.original.media, 2)
  },
  {
    id: 'valorTotal',
    accessorKey: 'valorTotal',
    header: 'Valor Total',
    size: 120,
    cell: ({ row }) => formatNumber(row.original.valorTotal, 2)
  },
  {
    id: 'faturamentoGeralMotorista',
    accessorKey: 'faturamentoGeralMotorista',
    header: 'Faturamento Geral',
    size: 140,
    cell: ({ row }) => formatNumber(row.original.faturamentoGeralMotorista, 2)
  },
  {
    id: 'valorPremiacao',
    accessorKey: 'valorPremiacao',
    header: 'Valor Premiação',
    size: 130,
    cell: ({ row }) => formatNumber(row.original.valorPremiacao, 2)
  },
  {
    id: 'valorPremiacaoAntesInfracao',
    accessorKey: 'valorPremiacaoAntesInfracao',
    header: 'Valor Antes Infração',
    size: 150,
    cell: ({ row }) => formatNumber(row.original.valorPremiacaoAntesInfracao, 2)
  },
  {
    id: 'porcentagemDescontoInfracao',
    accessorKey: 'porcentagemDescontoInfracao',
    header: '% Desconto Infração',
    size: 140,
    cell: ({ row }) => formatNumber(row.original.porcentagemDescontoInfracao, 2)
  },
  {
    id: 'quantidadeInfracoes',
    accessorKey: 'quantidadeInfracoes',
    header: 'Qtd Infrações',
    size: 110,
    cell: ({ row }) => row.original.quantidadeInfracoes ?? '-'
  },
  {
    id: 'descricaoInfracoes',
    accessorKey: 'descricaoInfracoes',
    header: 'Infrações',
    size: 180,
    cell: ({ row }) => renderTextCell(row.original.descricaoInfracoes, 24)
  },
  {
    id: 'porcentagemPremiacao',
    accessorKey: 'porcentagemPremiacao',
    header: '% Premiação',
    size: 120,
    cell: ({ row }) => row.original.porcentagemPremiacao || '-'
  },
  {
    id: 'nomeTabelaPremiacao',
    accessorKey: 'nomeTabelaPremiacao',
    header: 'Tabela',
    size: 160,
    cell: ({ row }) => renderTextCell(row.original.nomeTabelaPremiacao, 18)
  },
  {
    id: 'segmentoTabelaPremiacao',
    accessorKey: 'segmentoTabelaPremiacao',
    header: 'Segmento',
    size: 120,
    cell: ({ row }) => renderTextCell(row.original.segmentoTabelaPremiacao, 14)
  },
  {
    id: 'mediaIdealTabelaPremiacao',
    accessorKey: 'mediaIdealTabelaPremiacao',
    header: 'Média Ideal',
    size: 110,
    cell: ({ row }) => formatNumber(row.original.mediaIdealTabelaPremiacao, 2)
  },
  {
    id: 'mediaExcelenteTabelaPremiacao',
    accessorKey: 'mediaExcelenteTabelaPremiacao',
    header: 'Média Excelente',
    size: 130,
    cell: ({ row }) => formatNumber(row.original.mediaExcelenteTabelaPremiacao, 2)
  },
  {
    id: 'porcentagemDescontoTabelaPremiacao',
    accessorKey: 'porcentagemDescontoTabelaPremiacao',
    header: '% Desconto Tabela',
    size: 130,
    cell: ({ row }) => formatNumber(row.original.porcentagemDescontoTabelaPremiacao, 2)
  },
  {
    id: 'usuarioCriacaoTabelaPremiacao',
    accessorKey: 'usuarioCriacaoTabelaPremiacao',
    header: 'Usuário Criação',
    size: 140,
    cell: ({ row }) => renderTextCell(row.original.usuarioCriacaoTabelaPremiacao, 16)
  }
];
